<template>
  <basic-container>
    <el-dialog
      title="发票开具"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      :append-to-body="true"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="110px" v-if="dialogVisible">
        <el-form-item>
          <div style="margin: 20px 0">
            <el-divider content-position="left">销售方信息</el-divider>
          </div>
        </el-form-item>

        <el-form-item label="收费项目" required prop="feeTaxItemId" v-if="isQrCodePay">
          <el-select v-model="form.feeTaxItemId" style="width: 100%">
            <el-option
              v-for="(item,index) in feeTaxItemList"
              :key="index"
              :label="item.taxFeeSortName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="销售方信息" required prop="sellerId" v-if="isQrCodePay || isFacePay">
          <el-select v-model="form.sellerId" style="width: 100%">
            <el-option
              v-for="(item,index) in sellerList"
              :key="index"
              :label="item.sellerInfo"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="销售方信息" required prop="sellerId" v-if="!isQrCodePay && !isFacePay">
          <el-select v-model="form.sellerId" style="width: 100%">
            <el-option
              v-for="(item,index) in sellerList"
              :key="index"
              :label="item.sellerName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="票据类型" required valid="invoiceType">
          <el-select v-model="form.invoiceType" style="width: 100%">
            <el-option
              v-for="(item,index) in taxInvoiceTypeList"
              :key="index"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div style="margin: 20px 0">
            <el-divider content-position="left">购买方信息</el-divider>
          </div>
        </el-form-item>
        <el-form-item label="抬头类型">
          <el-radio-group v-model="form.headerType" @change="(value)=>headerTypeChange(value)">
            <el-radio border :label="1">个人/非企业单位</el-radio>
            <el-radio v-if="permission.invoice_enterprise" border :label="2">企业单位</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开票金额" prop="payAmount">
          <el-input class="invoiceAmount-input" v-model="form.payAmount" disabled></el-input>
        </el-form-item>
        <!--          @change="(value)=>invoiceHeaderChange(value)"-->
        <el-form-item label="发票抬头" prop="purchaserIdStr">
          <el-select
            style="width: 100%"
            allow-create
            v-model="form.purchaserIdStr"
            filterable
            :disabled="purchaserIdStrDisabled"
          >
            <el-option
              v-for="(item, index) in purchaserList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
              <span>{{item.searchShowName}}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.headerType == 2" label="纳税人识别号" prop="taxNo">
          <el-input v-model="form.taxNo" show-word-limit maxlength="20"></el-input>
        </el-form-item>

        <el-form-item :label="form.headerType == 2 ? '注册地址' : '地址'">
          <el-input v-model="form.address" show-word-limit maxlength="100"></el-input>
        </el-form-item>
        <el-form-item :label="form.headerType == 2 ? '注册电话' : '电话'" prop="invoicePhone">
          <el-input v-model="form.phone" show-word-limit maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="开户银行">
          <el-input v-model="form.depositBank" show-word-limit maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="开户银行账号">
          <el-input v-model="form.bankNo" show-word-limit maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="发票备注">
          <el-input type="textarea" :rows="2" v-model="form.description" show-word-limit maxlength="100"></el-input>
        </el-form-item>
        <!-- <el-form-item>
          <div style="margin: 20px 0">
            <el-divider content-position="left">发票接收方式</el-divider>
          </div>
        </el-form-item>
        <el-form-item label="电话" prop="receivePhone">
          <el-input v-model="form.receivePhone" show-word-limit maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="receiveMailbox">
          <el-input v-model="form.receiveMailbox" show-word-limit maxlength="50"></el-input>
        </el-form-item> -->

        <el-form-item>
          <el-button type="primary" @click="submit" :loading="debounce">开票</el-button>
          <el-button @click="handleClose" :loading="debounce">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <InvoiceDownloadDialog ref="InvoiceDownloadDialog" />
    <el-dialog title="提示"
               width="40%"
               :visible.sync="tipShow"
               :append-to-body="true"
               :modal-append-to-body="true"
               :close-on-click-modal="false"
               :destroy-on-close="true">
      <div class="plate-change-tip">
        <div class="t1">
          <!-- <span v-if="invoiceSuccess">开票成功！请问是否需要直接下载？</span> -->
          <span v-if="!invoiceSuccess">开票失败！失败原因：{{errorMsg}}</span>
          <br v-if="!invoiceSuccess">
          <span v-if="!invoiceSuccess">请解决问题后，重新开票！</span>
        </div>
      </div>
      <template slot="footer">
        <div>
          <!-- <el-button :loading="downloading" type="primary" @click="downloadFile">发票下载</el-button> -->
          <el-button @click="closeDialog">确 定</el-button>
        </div>
      </template>
    </el-dialog>

  </basic-container>

</template>

<script>
import { validation } from '@/util/validation';
import { getSellerList } from '@/api/v4ward/digitaltickets/feeSeller';
import { getInvoiceTypeList } from '@/api/v4ward/digitaltickets/invoiceType';
import { getPurchaserList } from '@/api/v4ward/digitaltickets/invoicePurchaser';
import { sdpInvoiceApply } from '@/api/v4ward/payrecord/index';
import { getAllSellerList } from "@/api/v4ward/digitaltickets/feeSeller";
import { getList } from "@/api/v4ward/digitaltickets/feeitemtax/FeeItemTax.js";
import { mapGetters } from "vuex";
import InvoiceDownloadDialog from './invoice-download-dialog';
export default {
  components: { InvoiceDownloadDialog },
  data() {
    return {
      purchaserIdStrDisabled:false,
      feeTaxItemList:[],
      //固定码收费开票
      isQrCodePay:false,
      isFacePay:false,
      //失败原因
      errorMsg:'',
      //发票地址
      blueInvoiceUrl:'',
      //发票号码
      blueInvoiceNo:'',
      downloading:false,
      tipShow:false,
      //默认开票失败
      invoiceSuccess:false,
      roomName:'',
      sellerList: [],
      taxInvoiceTypeList: [],
      purchaserList: [],
      dialogVisible: false,
      form: {
        sellerId: '',
        invoiceType: '',
        headerType: 1, //抬头类型:1-个人;2-企业
        payAmount: '',
        headerName: '',
        taxNo: '',
        address: '',
        phone: '',
        depositBank: '',
        bankNo: '',
        // receivePhone: '',
        // receiveMailbox: '',
        targetIds: '',
        purchaserIdStr:'',
        description:'',
      },
      rules: {
        purchaserIdStr: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' },
          { min: 1, max: 100, message: '输入长度应小于100个字符', trigger: 'change' },
        ],
        taxNo: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
          { validator: validation.taxNo(), message: '格式错误', trigger: 'blur' },
        ],
        /* phone: [
          {
            pattern: /^1\d{10}$|^(\d{3,4}-)?\d{7,8}(-\d{1,4})?$/,
            message: '格式错误',
            trigger: ['change', 'blur'],
          },
        ], */
      },
      debounce: false,
    };
  },
  computed: {
    ...mapGetters(['permission']),
    defaultHeaderType() {
      return this.permission.invoice_enterprise ? 2 : 1;
    }
  },
  watch:{
    "form.purchaserIdStr"(){
      let find = this.purchaserList.find(ele => ele.id == this.form.purchaserIdStr);
      if(find){
        this.form.taxNo = find.taxNo;
        this.form.headerName = find.name;
        this.form.address = find.address;
        this.form.phone = find.phone;
        this.form.depositBank = find.depositBank;
        this.form.bankNo = find.bankNo;
        // this.form.receivePhone = find.receivePhone;
        // this.form.receiveMailbox = find.receiveMailbox;
      }else{
        this.form.taxNo = '';
        this.form.headerName = '';
        this.form.address = '';
        this.form.phone = '';
        this.form.depositBank = '';
        this.form.bankNo = '';
        // this.form.receivePhone = '';
        // this.form.receiveMailbox = '';
      }
    },
    "form.sellerId"(){
      let filterSeller = this.sellerList.filter(ele => ele.id == this.form.sellerId);
      console.log('filterSeller>>', filterSeller);
      if(filterSeller && filterSeller[0] && filterSeller[0].feeInvoiceTypeId){
        console.log('查询type');
        getInvoiceTypeList({id:filterSeller[0].feeInvoiceTypeId}).then(({data})=>{
          this.taxInvoiceTypeList = data;
          if(data && data[0]){
            let filter = data.filter((ele) => ele.isDefault == 1);
            this.form.invoiceType = filter[0].code;
          }else{
            this.$message.warning("销售方关联的发票类型不存在，请检查数据");
            this.taxInvoiceTypeList = [];
            this.form.invoiceType = '';
          }
        });
      }else{
        if(this.form.sellerId){
          //存在销售方
          this.$message.warning("销售方未关联发票类型");
          this.taxInvoiceTypeList = [];
          this.form.invoiceType = '';
        }
      }
    }
  },
  methods: {
    downloadFile() {
      if(this.downloading){
        return;
      }
      this.downloading = true;
      if (this.blueInvoiceUrl) {
        const link = document.createElement('a');
        link.href = this.blueInvoiceUrl;
        link.setAttribute('download', this.blueInvoiceNo);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.downloading = false;
        this.closeDialog();
      } else {
        // 文件URL为空时的处理逻辑
        this.$message.error('文件不存在!');
        this.downloading = false;
      }
    },
    handleClose(){
      //初始化form表格内容
      console.log("初始化form表格内容");
      this.form = {
        sellerId: '',
        invoiceType: '',
        headerType: this.defaultHeaderType,
        payAmount: '',
        headerName: '',
        taxNo: '',
        address: '',
        phone: '',
        depositBank: '',
        bankNo: '',
        // receivePhone: '',
        // receiveMailbox: '',
        targetIds: '',
        purchaserIdStr: '',
        feeTaxItemId: '',
        description: '',
      };
      this.dialogVisible = false;
      this.isQrCodePay = false;
      this.isFacePay = false;
      this.purchaserIdStrDisabled = false;
    },
    invoiceHeaderChange(value){
      let find = this.purchaserList.find(ele => ele.id == value);
      if(find){
        this.form.taxNo = find.taxNo;
        this.form.headerName = find.name;
        this.form.address = find.address;
        this.form.phone = find.phone;
        this.form.depositBank = find.depositBank;
        this.form.bankNo = find.bankNo;
        // this.form.receivePhone = find.receivePhone;
        // this.form.receiveMailbox = find.receiveMailbox;
      }else{
        this.form.taxNo = '';
        this.form.headerName = '';
        this.form.address = '';
        this.form.phone = '';
        this.form.depositBank = '';
        this.form.bankNo = '';
        // this.form.receivePhone = '';
        // this.form.receiveMailbox = '';
      }
    },
    //父组件调用
    openDialog(params) {
      console.log('打开发票页面', params);
      this.form.headerType = this.defaultHeaderType;
      this.form.targetIds = params.feePayId;
      this.form.payAmount = params.payAmount;
      this.roomName = params.roomName;
      this.searchCommunityId = params.communityId;
      this.form.businessType = params.businessType;
      this.isQrCodePay = params.isQrCodePay;
      this.isFacePay = params.isFacePay;
      this.sellerId = params.sellerId;
      //月卡车相关信息
      this.remark2 = params.remark2;
      this.payBillNo = params.payBillNo;
      if (this.form.headerType == 1) {
        if(this.remark2 && this.payBillNo && /^YK/i.test(this.payBillNo)){
          this.form.purchaserIdStr = this.remark2;
        }else{
          this.form.purchaserIdStr = this.roomName;
        }
      }
      this.initData();
      this.dialogVisible = true;
      //如果抬头有默认值，则不允许修改
      if(this.form.purchaserIdStr){
        this.purchaserIdStrDisabled = true;
      }else{
        this.purchaserIdStrDisabled = false;
      }
    },
    initData(){
      console.log("isFacePay>>>", this.isFacePay)
      console.log("isQrCodePay>>>", this.isQrCodePay)
      let filterSellerId = this.sellerId;
      console.log("filterSellerId>>>", filterSellerId)
      if(this.isQrCodePay || this.isFacePay){
        //固定码缴费和面缴缴费记录
        getAllSellerList().then((res) => {
          if(res.data){
            this.sellerList = res.data.filter(ele => ele.id == filterSellerId);
            if(this.sellerList && this.sellerList.length > 0){
              this.form.sellerId = this.sellerList[0].id;
            }
          }else{
            this.sellerList =[];
          }
          console.log("this.sellerList>>", this.sellerList)
        });
      }else{
        //初始化销售方信息下拉框
        getSellerList({searchCommunityId:this.searchCommunityId}).then(({data})=>{
          this.sellerList = data;
          if(data && data[0]){
            let filter = data.filter((ele) => ele.isDefault == 1);
            this.form.sellerId = filter[0].id;
          }
        });
      }

      //初始化发票抬头下拉框
      getPurchaserList({headerType:this.form.headerType}).then(({data})=>{
        this.purchaserList = data;
      });

      if(this.isQrCodePay){
        //初始化税收分类列表
        getList().then(({data})=>{
          this.feeTaxItemList = data;
        });
      }else{
        this.feeTaxItemList = [];
      }
    },
    closeDialog() {
      this.handleClose();
      this.invoiceSuccess = false;
      this.blueInvoiceUrl = '';
      this.blueInvoiceNo = '';
      this.errorMsg = '';
      this.tipShow = false;
      this.purchaserIdStrDisabled = false;

      this.$emit('close');
    },
    headerTypeChange(value) {
      getPurchaserList({headerType:value}).then(({data})=>{
        this.purchaserList = data;
      });
      if(value == 1){
        if(this.remark2 && this.payBillNo && /^YK/i.test(this.payBillNo)){
          this.form.purchaserIdStr = this.remark2;
        }else{
          this.form.purchaserIdStr = this.roomName;
        }
      }else if(value == 2){
        this.form.purchaserIdStr = '';
      }
      //如果抬头有默认值，则不允许修改
      if(this.form.purchaserIdStr){
        this.purchaserIdStrDisabled = true;
      }else{
        this.purchaserIdStrDisabled = false;
      }
    },
    submit() {
      if (this.debounce) {
        console.log('防重提交');
        return;
      }
      if(!this.form.headerName && this.form.purchaserIdStr){
        this.form.headerName = this.form.purchaserIdStr;
      }
      this.debounce = true;
      this.$refs.form
        .validate()
        .then((res) => {
          /* if (!(this.form.receiveMailbox || this.form.receivePhone)) {
            this.$message({
              message: '请至少填写一个发票接收方式',
              type: 'warning',
            });
            this.debounce = false;
            return;
          }
          if (this.form.receiveMailbox) {
            let temp = /^(\w+)(\.\w+)*@(\w+)(\.\w+)*.(\w+)$/i.test(
              this.form.receiveMailbox
            );
            if (!temp) {
              this.$message({
                message: '邮箱格式错误',
                type: 'warning',
              });
              this.debounce = false;
              return;
            }
          }
          if (this.form.receivePhone) {
            let tempRes = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/.test(this.form.receivePhone);
            if (!tempRes) {
              this.$message({
                message: '手机格式错误',
                type: 'warning',
              });
              this.debounce = false;
              return;
            }
          } */
          if (this.form.headerType == 1) {
            //个人/非企业没有纳税人识别号
            this.form.taxNo = '';
          }
          this.form.invoiceSource = 'PC';
          console.log('this.form>>>>', this.form);
          sdpInvoiceApply(this.form).then(({data})=>{
            this.debounce = false;
            this.invoiceSuccess = data.success;
            if (this.invoiceSuccess) {
              let invoiceData = {
                source: 'invoiceSuccess',
                invoiceUrl: data.blueInvoiceUrl,
                invoiceNo: data.blueInvoiceNo,
              };
              this.$refs.InvoiceDownloadDialog.openDialog(invoiceData);
              this.closeDialog();
              return;
            }
            this.blueInvoiceUrl = data.blueInvoiceUrl;
            this.blueInvoiceNo = data.blueInvoiceNo;
            this.errorMsg = data.failMsg;
            this.tipShow = true;
          }).catch((err) => {
            this.debounce = false;
            this.$message.error(err)
          });
        })
        .catch((err) => {
          this.debounce = false;
          console.log('参数校验失败==>',err);
        });
    },
  },
  created() {},
};
</script>

<style>
/*控制输入框的问题字体成红色 !important*/
.invoiceAmount-input .el-input__inner {
  color: red;
}
</style>
